export default function formateDate(date, opt) {
  let newDate = new Date(date);
  const month =
    newDate.getUTCMonth() + 1 >= 10
      ? newDate.getUTCMonth() + 1
      : "0" + (newDate.getUTCMonth() + 1);
  const day =
    newDate.getUTCDate() >= 10
      ? newDate.getUTCDate()
      : "0" + newDate.getUTCDate();
  const year = newDate.getUTCFullYear();

  if (opt === "getDateTime") {
    const [year, month, day] = date.split("-");

    return `${year}-${month}-${day} 00:00:00`;
  }

  return opt === "pickDate"
    ? `${year}-${month}-${day}`
    : `${month}-${day}-${year}`;
}
